import { render, staticRenderFns } from "./MapPopupHotelCard.vue?vue&type=template&id=484dbbbb&"
import script from "./MapPopupHotelCard.vue?vue&type=script&lang=js&"
export * from "./MapPopupHotelCard.vue?vue&type=script&lang=js&"
import style0 from "./MapPopupHotelCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports